import { FunctionalComponent, h } from 'preact';

import { LoaderTemplatePropsInterface } from 'common/module/loader/template-props.interface';

export const LoaderTemplate: FunctionalComponent<LoaderTemplatePropsInterface> = (props): preact.JSX.Element =>
  props.isEnabled && (
    <div className='loader1'>
      <div
        className={`
      loader1__spinner
      ${props.isCentered ? 'loader1__spinner--centered' : ''}
    `}
      >
        <div className='loader1__bounce loader1__bounce--1' />
        <div className='loader1__bounce loader1__bounce--2' />
        <div className='loader1__bounce loader1__bounce--3' />
      </div>
    </div>
  );
